import axiosInstance from '@/utils/api.js'

var state = {
  services: []
}

var getters = {
  SERVICES: (state) => {
    return state.services
  }
}

var mutations = {
  SET_SERVICES: (state, payload) => {
    state.services = payload
  }
}

var actions = {
  GET_SERVICES: async (context, payload) => {
    let result = await axiosInstance.get('/reports/services?start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd +
    '&user_id=' + payload.userId +
    '&account_id=0&accounting_period_id=0' + '&group_id=' + payload.group_id +
    '&accs_group_id=' + payload.accs_group_id +
    '&limit=' + payload.limit + '&download=' + payload.download, {timeout: 45000})
    if (result.status === 200) {
      context.commit('SET_SERVICES', result.data)
    }
  },
  CLEAR_SERVICES: (context) => {
    context.commit('SET_SERVICES', [])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/reports/services.js